import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { CONFIG_ITEM_KEYS } from '../../../ui/prebuilt/config-items/config-item-keys';
import { getAllEditorPluginAIConfigItems } from '../../../ui/prebuilt/config-items/config-items';
import { suggestTitleForConfluenceTitleToolbar } from '../../../ui/prebuilt/config-items/prompts/suggest-title/suggest-title';
import { EventHubPrompt } from '../types';
var getConfigFromProvider = function getConfigFromProvider(editorPluginAIProvider, configType, key) {
  if (key === CONFIG_ITEM_KEYS.FREE_GENERATE) {
    return editorPluginAIProvider.baseGenerate;
  } else {
    var configItem = getAllEditorPluginAIConfigItems({
      configItemWithOptions: editorPluginAIProvider.configItemWithOptions
    }).find(function (suggestion) {
      return suggestion.key === key;
    });
    return configItem;
  }
};
var getConfigTypeByAdjustSelection = function getConfigTypeByAdjustSelection(adjustSelection) {
  switch (adjustSelection) {
    case 'fullDocument':
      {
        return 'rangeConfig';
      }
    case 'keepCurrent':
      {
        return 'rangeConfig';
      }
    default:
      {
        return 'emptyConfig';
      }
  }
};
export var getConfigItem = function getConfigItem(prompt, editorPluginAIProvider, adjustSelection, additionalPayloadDataIssueReformatter) {
  switch (prompt) {
    case EventHubPrompt.SuggestTitleConfluenceTitleToolbar:
      {
        return suggestTitleForConfluenceTitleToolbar;
      }
    case EventHubPrompt.SuggestTitle:
      {
        var suggestTitle = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.SUGGEST_A_TITLE);
        return suggestTitle;
      }
    case EventHubPrompt.DraftReply:
      {
        var draftReply = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.SUGGEST_REPONSE);
        return draftReply;
      }
    case EventHubPrompt.CustomPrompt:
      {
        var freeGenerate = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.FREE_GENERATE);
        return freeGenerate;
      }
    case EventHubPrompt.IssueReformatter:
      {
        var issueReformatter = getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', CONFIG_ITEM_KEYS.ADD_STRUCTURE);
        return getIssueReformatterModifiedConfigItem(issueReformatter, additionalPayloadDataIssueReformatter);
      }
    case EventHubPrompt.Summarize:
      {
        var summarize = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.SUMMARISE_WRITING);
        return summarize;
      }
    case EventHubPrompt.ImproveWriting:
      {
        var improveWriting = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.IMPROVE_WRITING);
        return improveWriting;
      }
    case EventHubPrompt.MakeShorter:
      {
        var makeShorter = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.MAKE_SHORTER);
        return makeShorter;
      }
    case EventHubPrompt.FixSpellingGrammar:
      {
        var fixSpellingGrammar = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.FIX_SPELLING_AND_GRAMMAR);
        return fixSpellingGrammar;
      }
    case EventHubPrompt.ChangeToneToProfessional:
      {
        var professionalTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_PROFESSIONAL);
        return professionalTone;
      }
    case EventHubPrompt.ChangeToneToNeutral:
      {
        var neutralTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_NEUTRAL);
        return neutralTone;
      }
    case EventHubPrompt.ChangeToneToEmpathetic:
      {
        var empatheticTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EMPATHETIC);
        return empatheticTone;
      }
    case EventHubPrompt.ChangeToneToCasual:
      {
        var _empatheticTone = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_CASUAL);
        return _empatheticTone;
      }
    case EventHubPrompt.ChangeToneToEducational:
      {
        var _empatheticTone2 = getConfigFromProvider(editorPluginAIProvider, getConfigTypeByAdjustSelection(adjustSelection), CONFIG_ITEM_KEYS.CHANGE_TONE_TO_EDUCATIONAL);
        return _empatheticTone2;
      }
    default:
      {
        return undefined;
      }
  }
};
export var shouldReturnFallbackSuggestedTitle = function shouldReturnFallbackSuggestedTitle(configItem, currentEditorView) {
  return (configItem === null || configItem === void 0 ? void 0 : configItem.key) === CONFIG_ITEM_KEYS.SUGGEST_A_TITLE && currentEditorView.state.doc.textContent.trim() === '';
};
export var getIssueReformatterModifiedConfigItem = function getIssueReformatterModifiedConfigItem(configItem, additionalPayload) {
  // Proactive description completer config item when enable convo-ai
  if (fg('migrate_editor_issue_reformatter_to_convo-ai')) {
    if (configItem !== null && configItem !== void 0 && configItem.getRequestPayload && (additionalPayload === null || additionalPayload === void 0 ? void 0 : additionalPayload.feature) === 'PROACTIVE_IMPROVE_DESCRIPTION') {
      var modifiedConfigItem = _objectSpread(_objectSpread({}, configItem), {}, {
        experienceId: 'jira-work-completer',
        getRequestPayload: function getRequestPayload() {
          var _configItem$getReques;
          for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
            params[_key] = arguments[_key];
          }
          var requestPayload = ((_configItem$getReques = configItem.getRequestPayload) === null || _configItem$getReques === void 0 ? void 0 : _configItem$getReques.call.apply(_configItem$getReques, [configItem].concat(params))) || {};
          if (requestPayload.ai_feature_input) {
            // Add additional payload from description completer to agent_input_context
            var ai_feature_input = _objectSpread(_objectSpread({}, requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.ai_feature_input), additionalPayload);
            return _objectSpread(_objectSpread({}, requestPayload), {}, {
              ai_feature_input: ai_feature_input
            });
          }
          return requestPayload;
        }
      });
      return modifiedConfigItem;
    }
  }

  // Proactive description completer config item when use assistant service
  if (configItem !== null && configItem !== void 0 && configItem.getRequestPayload && (additionalPayload === null || additionalPayload === void 0 ? void 0 : additionalPayload.feature) === 'proactive-improve-description') {
    var _modifiedConfigItem = _objectSpread(_objectSpread({}, configItem), {}, {
      experienceId: 'jira-work-completer',
      getRequestPayload: function getRequestPayload() {
        var _configItem$getReques2;
        for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }
        var requestPayload = ((_configItem$getReques2 = configItem.getRequestPayload) === null || _configItem$getReques2 === void 0 ? void 0 : _configItem$getReques2.call.apply(_configItem$getReques2, [configItem].concat(params))) || {};
        if (requestPayload.agent_input_context) {
          // Add additional payload from description completer to agent_input_context
          var agent_input_context = _objectSpread(_objectSpread({}, requestPayload === null || requestPayload === void 0 ? void 0 : requestPayload.agent_input_context), additionalPayload);
          return _objectSpread(_objectSpread({}, requestPayload), {}, {
            agent_input_context: agent_input_context
          });
        }
        return requestPayload;
      }
    });
    return _modifiedConfigItem;
  }
  return configItem;
};